import Swiper from 'swiper/dist/js/swiper.js';
import lightGallery from "lightgallery/dist/js/lightgallery.js"; // eslint-disable-line
import "lg-zoom";
import "lg-thumbnail";

export default {
  init() {
    jQuery(window).on('load', function() {
      /* Slider */
      if(jQuery(".product-slider .swiper-slide:not(.swiper-slide-duplicate)").length == 1) {
        jQuery('.product-slider .product-slider-next').hide();
        jQuery('.product-slider .product-slider-prev').hide();
      }

      if(jQuery(".product-slider .swiper-slide:not(.swiper-slide-duplicate)").length > 1) {
        new Swiper('.product-slider', {
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          loop: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          speed: 600,
          spaceBetween: 100,
          centeredSlides: true,
          slidesPerView: 1,
          setWrapperSize: true,
          navigation: {
            nextEl: '.product-slider-next',
            prevEl: '.product-slider-prev',
          },
          on: {
            init: function () {
              if(jQuery("body.gift-card, body.carte-cadeau").length == 0) {
                  jQuery('.product-slider .swiper-wrapper').lightGallery({
                  mode: 'lg-zoom-in-out',
                  selector: '.swiper-slide:not(.swiper-slide-duplicate)',
                  thumbnail: true,
                  download: false,
                  preload: 3,
                  getCaptionFromTitleOrAlt: false,
                  showThumbByDefault: false,
                });
              }
            },
            resize: function () {
              this.update();
            },
          },
        });
      }

      new Swiper('.bienfaits-slider', {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false,
        },
        spaceBetween: 50,
        simulateTouch: false,
        speed: 600,
        centeredSlides: true,
        parallax: true,
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.side-next',
        },
        on: {
          resize: function () {
            this.update();
          },
        },
      });

      new Swiper('.composition-slider', {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false,
        },
        spaceBetween: 100,
        speed: 600,
        parallax: true,
        simulateTouch: false,
        effect: 'fade',
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        setWrapperSize: false,
        navigation: {
          nextEl: '.composition-next',
        },
        on: {
          resize: function () {
            this.update();
          },
        },
      });

      new Swiper('.application-slider', {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false,
        },
        spaceBetween: 100,
        speed: 600,
        simulateTouch: false,
        parallax: true,
        effect: 'fade',
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        setWrapperSize: true,
        navigation: {
          nextEl: '.application-next',
          prevEl: '.application-prev',
        },
        on: {
          resize: function () {
            this.update();
          },
        },
      });

      new Swiper('.swiper-container-crosssells', {
        // Default parameters
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        setWrapperSize: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is <= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          // when window width is <= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          // when window width is <= 640px
          640: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
        on: {
          resize: function () {
            this.update();
          },
        },
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    jQuery('.pomelo-review-link-modal').on('click', function() {
      jQuery('#modal-reviews').on('shown.bs.modal', function () {
          jQuery('#modal-reviews').animate({
            scrollTop: jQuery('#review_form_wrapper').offset().top,
          }, 500);
        }).on('hide.bs.modal', function () {
          jQuery('#modal-reviews').off();
      });
    });

    jQuery('#product-qty').on('change', function() {
      jQuery('body').trigger('woocommerce_variation_has_changed');
    });

    jQuery(document).on('click', 'a[href="#review_form"]', function (event) {
      event.preventDefault();
      jQuery('#modal-reviews').animate({
        scrollTop: jQuery('#modal-reviews').offset().top,
      }, 500);
    });

    jQuery('body').on('show_variation woocommerce_variation_has_changed', function() {
      let $variation = jQuery('.variations').find('select');
      let variationName = $variation.attr('name');
      let variationVal = $variation.val();
      jQuery('.add_to_cart_button').data('product_id', jQuery('input[name="variation_id"]').val());
      jQuery('.add_to_cart_button').data('variation_id', jQuery('input[name="variation_id"]').val());
      jQuery('.add_to_cart_button').data('quantity', jQuery('select[name="quantity"]').val());
      jQuery('.add_to_cart_button').data(variationName, variationVal);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js